module.exports = __webpack_public_path__ + "media/fonts/atlasPro/AtlasProAAA-Regular-8f14e7cfdd318af5a3abb6e2bb976fdf.woff2";